import { DefaultJwtVerifier } from './adapter/defaults.js';
import { StandardLogtoClient } from './client.js';
export { LogtoError, LogtoRequestError, OidcError, Prompt, ReservedResource, ReservedScope, UserScope, buildOrganizationUrn, getOrganizationIdFromUrn, isLogtoRequestError, organizationUrnPrefix } from '@logto/js';
export { LogtoClientError } from './errors.js';
import '@silverhand/essentials';
export { CacheKey, PersistKey } from './adapter/types.js';
export { createRequester } from './utils/requester.js';
export { isLogtoAccessTokenMap, isLogtoSignInSessionItem, normalizeLogtoConfig } from './types/index.js';

/**
 * The Logto base client class that provides the essential methods for
 * interacting with the Logto server.
 *
 * It also provides an adapter object that allows the customizations of the
 * client behavior for different environments.
 */
class LogtoClient extends StandardLogtoClient {
    constructor(logtoConfig, adapter, buildJwtVerifier) {
        super(logtoConfig, adapter, buildJwtVerifier ?? ((client) => new DefaultJwtVerifier(client)));
    }
}

export { StandardLogtoClient, LogtoClient as default };
